import React from "react";
import { cn } from "@/lib/utils";

// Bouton principal : pilule, hauteur 56px, texte Archivo.
// Actif : rouge, texte blanc. Inactif : #1A1A1A, texte #555555.
export const PrimaryCTA = ({
    children,
    onClick,
    disabled = false,
    type = "button",
    className,
    dataTestId = "primary-cta",
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            data-testid={dataTestId}
            className={cn(
                "tap-feedback w-full rounded-full font-body font-semibold text-base",
                "flex items-center justify-center select-none",
                "active:scale-[0.98]",
                className,
            )}
            style={{
                height: "var(--h-button)",
                backgroundColor: disabled ? "#1A1A1A" : "var(--red)",
                color: disabled ? "#555555" : "#FFFFFF",
                pointerEvents: disabled ? "none" : "auto",
                transition: "transform var(--dur-touch) var(--ease)",
            }}
        >
            {children}
        </button>
    );
};
